export default __webpack_public_path__ + "static/media/link.633783c8.svg";